import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'

export const ToggleWrapper = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}))
